module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/3@2x_91168f68119693221c4e96b3644ddcd5.png";